import { render, staticRenderFns } from "./TheWizardNavItem.vue?vue&type=template&id=0e49e130&scoped=true&"
import script from "./TheWizardNavItem.vue?vue&type=script&lang=js&"
export * from "./TheWizardNavItem.vue?vue&type=script&lang=js&"
import style0 from "./TheWizardNavItem.vue?vue&type=style&index=0&id=0e49e130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e49e130",
  null
  
)

export default component.exports